<template>
  <div class="dynamic-tags__section">
    <div class="tags">
      <section :class="tagClass">
        <div
            v-for="(tag, index) in dynamicTags"
            :key="index"
            :style="tagStyle">
          <el-tooltip
              placement="top"
              effect="light"
              :disabled="!tag.instruction"
              :class="{ 'tag-with-tooltip': !!tag.instruction }">
            <div slot="content">
              <section
                  v-if="tag.instruction"
                  style="word-break: normal"
                  v-html="tag.instruction" />
              <div v-else>
                N/A
              </div>
            </div>
            <el-alert
                style="word-break: normal"
                class="device-dynamic-tag"
                :title="tag.name"
                type="error"
                :closable="false" />
          </el-tooltip>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: "Tags",
  props: {
    // eslint-disable-next-line vue/require-default-prop
    tagsDirection: {
      type: String,
      required: false,
      default: "col",
      validator(value) {
        return ["col", "row"].includes(value);
      },
    },
    list: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  computed: {
    tagClass() {
      return this.tagsDirection === "col" ? "flex flex-col" : "flex flex-wrap";
    },
    tagStyle() {
      return this.tagsDirection === "col"
        ? { marginTop: "4px", maxWidth: "max-content" }
        : { marginLeft: "3px ", marginTop: "4px", maxWidth: "max-content" };
    },
    dynamicTags() {
      return this.list.map((item) => ({
        name: item.display_name || item.tag,
        instruction: item.instruction,
      }));
    },
  },
  methods: {},
};
</script>

<style lang="scss">
.el-table .cell {
  padding: 0;
}
.dynamic-tags__section {
  padding: 2px;
  .el-alert {
    padding: 6px 13px;
  }

  .el-alert--error.is-light {
    background-color: rgb(255, 210, 210);
  }
  .device-dynamic-tag {
    .el-alert__title {
      font-size: 0.8rem !important;
    }
  }
  .tag-with-tooltip {
    border-width: thin;
    border-color: #d71b00;
    box-shadow: 0 1px 2px 0 rgba(12, 12, 13, 0.2),
      0 0 0 1px rgba(215, 27, 0, 0.25);
    cursor: help;
  }
}
</style>
